import React from 'react';

export const HOMESERVICE_PAYMENT_METHODS = {
	ENCAR_LOAN: 'ENCAR_LOAN',
	CASH: 'CASH',
	ENCAR_PAY: 'ENCAR_PAY',
};

// 약관 바텀시트 체크 항목 name → 재신청 API termsConsents[].termsType
export const HOMESERVICE_TERMS_TYPE = {
	refundRule: 'MEETGO_DELIVERY_REFUND_RULE', // 엔카믿고 환불약관 동의 (항상)
	privacyWarranty: 'WARRANTY_PERSONAL_INFO', // 엔카종합보증 개인정보 수집/이용 동의
	provide: 'WARRANTY_THIRD_PARTY_PROVISION', // 엔카종합보증 개인정보 제3자 제공 동의 (국산차만 노출)
	refundWarranty: 'WARRANTY_USAGE_REFUND_RULE', // 엔카종합보증 이용 및 환불 규정 동의
};

export const TERMS_CONSENT_STATUS = {
	AGREE: 'AGREE',
	DECLINE: 'DECLINE',
};

export const HOMESERVICE_NOMINEE_TYPE = {
	PERSONAL_MAIN: 'PERSONAL_MAIN', // 개인
	PERSONAL_BUSINESS_MAIN: 'PERSONAL_BUSINESS_MAIN', // 개인사업자
	CORPORATION_BUSINESS_MAIN: 'CORPORATION_BUSINESS_MAIN', // 법인사업자
	PERSONAL_JOINT: 'PERSONAL_JOINT', // 개인 공동명의자
	PERSONAL_BUSINESS_JOINT: 'PERSONAL_BUSINESS_JOINT', // 개인사업자 공동명의자
};

export const DESIRED_TIME_OPTIONS = [
	{
		text: '이른 아침 (08:30 ~ 09:00)',
		value: 'A_EARLY_MORNING',
	},
	{
		text: '오전 (09:00 ~ 12:00)',
		value: 'B_MORNING',
	},
	{
		text: '점심 직후 (13:00 ~ 14:00)',
		value: 'C_AFTER_LUNCH',
	},
	{
		text: '오후 (14:00 ~ 17:00)',
		value: 'D_AFTERNOON',
	},
	{
		text: '모든 시간 가능해요.',
		value: 'E_ALL_DAY',
	},
];

const CONFIRM_PROCESS_COMMON_SUB_TEXT = '자세한 문의는 고객센터 1599-5455로 연락해주세요';

export const CONFIRM_PROCESS_RESULT_TYPE = {
	COMPLETE_DEALER_UNAVAILABLE_SELLING: 'COMPLETE_DEALER_UNAVAILABLE_SELLING',
	COMPLETE_DEALER_UNAVAILABLE_FOR_LEASE_RENT: 'COMPLETE_DEALER_UNAVAILABLE_FOR_LEASE_RENT',
	COMPLETE_DEALER_CAN_SELLING: 'COMPLETE_DEALER_CAN_SELLING',
	COMPLETE_CUSTOMER_CONFIRMATION: 'COMPLETE_CUSTOMER_CONFIRMATION',
	COMPLETE_CUSTOMER_CANCEL: 'COMPLETE_CUSTOMER_CANCEL',
	ERROR_NOT_FOUND_APPLICATION: 'ERROR_NOT_FOUND_APPLICATION',
	ERROR_IS_CONSULTING_PROGRESS: 'ERROR_IS_CONSULTING_PROGRESS',
	ERROR_IS_ORDERING_PROGRESS: 'ERROR_IS_ORDERING_PROGRESS',
	ERROR_CANCEL_OR_REFUND_PROGRESS: 'ERROR_CANCEL_OR_REFUND_PROGRESS',
	ERROR_CONFIRM_PURCHASE_PROGRESS: 'ERROR_CONFIRM_PURCHASE_PROGRESS',
	CANNOT_MODIFY_AVAILABLE_SALE: 'CANNOT_MODIFY_AVAILABLE_SALE',
	ALREADY_EXIST_AVAILABLE_SALE_RESPONSE: 'ALREADY_EXIST_AVAILABLE_SALE_RESPONSE',
	ERROR_EXPIRED_KEY: 'ERROR_EXPIRED_KEY',
};

export const CONFIRM_PROCESS_RESULT_TYPE_TEXT = {
	// 선택 성공상태
	[CONFIRM_PROCESS_RESULT_TYPE.COMPLETE_DEALER_UNAVAILABLE_SELLING]: {
		summary: '판매가능 여부 확인 완료',
		title: (
			<>
				판매 불가한 차량으로
				<br />
				확인 되었어요
			</>
		),
		subText: [
			<>
				차량이 판매/예약된 경우 차량 상태를
				<br />
				바로 변경해 주세요.
				<br />
				판매 불가 응답이 잦을 경우
				<br />
				제휴에 영향이 있을 수 있어요.
			</>,
		],
	},
	[CONFIRM_PROCESS_RESULT_TYPE.COMPLETE_DEALER_UNAVAILABLE_FOR_LEASE_RENT]: {
		summary: '차량 확인 완료',
		title: (
			<>
				위탁/리스 차량으로
				<br />
				확인 되었어요
			</>
		),
		subText: [
			<>
				엔카믿고로 등록된 위탁/리스 차량이 더 있으신 경우
				<br />
				담당 컨설턴트에게 공유해 주세요.
			</>,
		],
	},
	[CONFIRM_PROCESS_RESULT_TYPE.COMPLETE_DEALER_CAN_SELLING]: {
		summary: '판매가능 여부 확인 완료',
		title: (
			<>
				판매 가능한 차량으로
				<br />
				확인 되었어요
			</>
		),
		subText: [
			<>
				아직 검수가 되지 않은 차량이라면
				<br />
				미리 사진을 준비해 주세요.
				<br />
				꼼꼼히 촬영할수록 판매 확률이 더 높아져요.
			</>,
		],
	},
	[CONFIRM_PROCESS_RESULT_TYPE.COMPLETE_CUSTOMER_CONFIRMATION]: {
		title: (
			<>
				신청이 완료되었어요.
				<br />
				홈서비스 상담사가 차량 검수 후<br />
				진행 사항을 안내해드려요.
			</>
		),
		subText: CONFIRM_PROCESS_COMMON_SUB_TEXT,
	},
	[CONFIRM_PROCESS_RESULT_TYPE.COMPLETE_CUSTOMER_CANCEL]: {
		title: '홈서비스 신청이 취소되었습니다.',
	},
	// 선택 불가상태
	[CONFIRM_PROCESS_RESULT_TYPE.ERROR_NOT_FOUND_APPLICATION]: {
		title: '홈서비스 주문정보가 조회되지 않습니다.',
		subText: CONFIRM_PROCESS_COMMON_SUB_TEXT,
	},
	[CONFIRM_PROCESS_RESULT_TYPE.ERROR_IS_CONSULTING_PROGRESS]: {
		title: '홈서비스 상담이 진행중입니다.',
		subText: CONFIRM_PROCESS_COMMON_SUB_TEXT,
	},
	[CONFIRM_PROCESS_RESULT_TYPE.ERROR_IS_ORDERING_PROGRESS]: {
		title: '홈서비스 주문이 진행중입니다.',
		subText: CONFIRM_PROCESS_COMMON_SUB_TEXT,
	},
	[CONFIRM_PROCESS_RESULT_TYPE.ERROR_CANCEL_OR_REFUND_PROGRESS]: {
		title: (
			<>
				홈서비스 취소 또는 환불된
				<br />
				접수건입니다.
			</>
		),
		subText: CONFIRM_PROCESS_COMMON_SUB_TEXT,
	},
	[CONFIRM_PROCESS_RESULT_TYPE.ERROR_CONFIRM_PURCHASE_PROGRESS]: {
		title: (
			<>
				홈서비스 구매확정이 완료된
				<br />
				접수건입니다.
			</>
		),
		subText: CONFIRM_PROCESS_COMMON_SUB_TEXT,
	},
	[CONFIRM_PROCESS_RESULT_TYPE.CANNOT_MODIFY_AVAILABLE_SALE]: {
		title: '홈서비스 차량 판매가능 여부를 변경할 수 없습니다.',
		subText: CONFIRM_PROCESS_COMMON_SUB_TEXT,
	},
	[CONFIRM_PROCESS_RESULT_TYPE.ALREADY_EXIST_AVAILABLE_SALE_RESPONSE]: {
		title: '이미 판매가능 여부를 응답하셨습니다.',
		subText: CONFIRM_PROCESS_COMMON_SUB_TEXT,
	},
	// 만료된 키
	[CONFIRM_PROCESS_RESULT_TYPE.ERROR_EXPIRED_KEY]: {
		title: (
			<>
				새로운 확인 요청이 접수돼서
				<br />
				해당 페이지는 만료됐습니다.
				<br />
				가장 최근 판매 여부 알림톡을
				<br />
				확인해주세요!
			</>
		),
	},
};

export const HOMESERVICE_SHIPPING_COST = {
	MAXIMUM_COST: 190000,
	MINIMUM_COST: 40000,
};

// 홈서비스 타입 (재신청, 신규신청)
export const APPLY_TYPE = {
	REAPPLY: 'REAPPLY',
	APPLY: 'APPLY',
};

export const ESTIMATE_PAYMENT_TYPE = {
	선불결제: 'PRE_PAID',
	후불결제: 'POST_PAID',
};
export const ESTIMATE_PAYMENT_TYPE_LABEL = {
	PRE_PAID: '선불결제',
	POST_PAID: '후불결제',
};

export const HOMERSERVICE_APPLY_INFLOW = {
	ACQUISITION_COST: 'ACQUISITION_COST', // 총비용계산기
	EVENT_MALL_FREE_INTEREST: 'eventMallFreeInterest', // 이벤트몰 무이자 할부
};

export const isFreeInterestInflow = (inflow) => inflow === HOMERSERVICE_APPLY_INFLOW.EVENT_MALL_FREE_INTEREST;
